<template>
  <div class="rate-promotions">
    <rate-deal v-if="show === 'deal' && !points_available" />
    <rate-value-adds v-if="show === 'value_adds'" :value_adds="promotions.value_adds" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RateDeal from "@liveeps/components/atoms/rate-deal"
import RateValueAdds from "@liveeps/components/atoms/rate-value-adds"

export default {
  name: 'rate-promotions',

  components: {
    'rate-deal': RateDeal,
    'rate-value-adds': RateValueAdds,
  },

  props: {
    show: {
      type: String,
      default: 'deal',
    },
    promos: Object
  },

  data() {
    return {
    }
  },

  computed: {

    ...mapGetters([
      'points_available'
    ]),

    promotions() {
      const promotions = this.promos
      if (!promotions) return {}

      return {
        value_adds: promotions.value_adds
      }
    },
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>
</style>